export default "__VITE_ASSET__DqyVoikE__"